import { memo } from 'react';

import { type Notification } from '@air/api/types';
import { type NotificationsItemProps } from '@air/component-notifications';

import { NotificationBaseItem } from '~/components/AirNotifications/components/NotificationBaseItem';
import { NotificationShareLinkIcon } from '~/components/AirNotifications/components/NotificationShareLinkIcon';
import { useShortUrlNotificationParentName } from '~/components/AirNotifications/hooks/useShortUrlNotificationParentName';

type NotificationShareLinkNotDownloadedTypeProps = {
  notification: Notification<'shareLinkNotDownloaded_userIsShareLinkCreator', 'account'>;
} & Pick<NotificationsItemProps, 'onClick'>;

export const NotificationShareLinkNotDownloadedType = memo(
  ({ notification, onClick }: NotificationShareLinkNotDownloadedTypeProps) => {
    const { shortUrl } = notification.data;

    const { shortUrlParentName } = useShortUrlNotificationParentName(shortUrl);

    return (
      <NotificationBaseItem
        meta={shortUrlParentName ? `in ${shortUrlParentName}` : ''}
        onClick={onClick}
        notification={notification}
        prefix={<NotificationShareLinkIcon />}
        title={
          <>
            A link to <b>{shortUrl.objectName}</b> has no downloads yet
          </>
        }
      />
    );
  },
);

NotificationShareLinkNotDownloadedType.displayName = 'NotificationShareLinkNotViewedType';
